export const isLocal = () => {
  if (!process || !process.env) return false

  return process.env.NODE_ENV === 'development' && (process.env.LOCAL === true || process.env.LOCAL === 'true')
}
